import React from 'react';

import InputLabel from 'components/inputfields/InputLabel';
import IProduct from 'models/product';
import { FloatInputDebounced } from '../FloatInput';
import ThreeWaySwitch from 'components/inputfields/ThreeWaySwitch';

interface IProps {
  readOnly?: boolean;
  state: IProduct;
  approve?: boolean;
  setState: React.Dispatch<React.SetStateAction<IProduct>>;
}

export const BurningTime = ({ readOnly, approve, state, setState }: IProps) => {
  return (
    <>
      <InputLabel heading="Brinntid" />
      <div style={{ display: 'flex', width: '100%', alignItems: 'start' }}>
        <div style={{ flex: 1, display: 'flex', width: '100%', gap: 8, alignItems: 'center' }}>
          <FloatInputDebounced<IProduct>
            readOnly={readOnly}
            dense={false}
            label="Brinntid i timmar"
            name="burningTime"
            state={state}
            setState={setState}
            style={{ marginBottom: 0, width: 220, flex: 'none' }}
          />
          <h3 style={{ margin: 0 }}>&nbsp;timmar</h3>
        </div>
        {approve && state?.approve?.find(x => x.field === 'burningTime') && (
          <ThreeWaySwitch
            readOnly={readOnly}
            state={state}
            setState={setState}
            name="burningTime"
            style={{ marginTop: 10 }}
          />
        )}
      </div>
    </>
  );
};

export default BurningTime;
